// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

export const PaymentMethod: MarkdocTagRegistration = {
  tag: 'payment-method',
  description:
    'Renders a payment method icon and label with and optional subtitle',
  component: 'PaymentMethod',
  selfClosing: true,
  attributes: {
    type: {
      type: String,
      description:
        "The name of the payment method icon (see Sail's BrandIconType)",
      required: true,
    },
    size: {
      type: String,
      description:
        "The size of the rendered icon. 'small', 'medium', 'large', 'xlarge'.",
      default: 'medium',
      required: false,
    },
    label: {
      type: String,
      description: 'The label to render next to the icon',
      required: false,
    },
    href: {
      type: Href,
      description: 'Optional href to make the payment method a link',
      required: false,
    },
    sublabel: {
      type: String,
      description: 'Small optional sublabel text',
      required: false,
    },
  },
};
